import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import cn from 'classnames'

const TestimonialsHalf = ({ testimonials }) => {
  const { allDatoCmsTestimonial } = useStaticQuery(graphql`
    query TestimonialHalfQuery {
      allDatoCmsTestimonial(
        filter: { categories: { elemMatch: { title: { eq: "Generic" } } } }
        limit: 2
      ) {
        edges {
          node {
            ...TestimonialsFragment
          }
        }
      }
    }
  `)

  const allTestimonials =
    testimonials.length > 0 ? testimonials : allDatoCmsTestimonial.edges

  return (
    <section id="testimonials" className="c-testimonial c-testimonial--half">
      <div className="c-testimonial__outer container">
        <div className="c-testimonial__inner">
          <div className="row">
            {allTestimonials.map(({ node }, i) => (
              <div
                key={node.id}
                className={cn('c-testimonialItem col-12', {
                  'col-md-6': allTestimonials.length > 1,
                  'd-none d-md-block': i === 1,
                })}
              >
                <GatsbyImage
                  image={getImage(node.companyLogo.gatsbyImageData)}
                  className="c-testimonial__compLogo"
                  alt={node.companyLogo.alt}
                  title={node.companyLogo.title}
                />

                <q className="c-testimonial__body mb-4">{node.body}</q>
                <div className="c-testimonial__author mt-3">
                  {node.avatar && (
                    <GatsbyImage
                      image={getImage(node.avatar.gatsbyImageData)}
                      className="c-testimonial__author__avatar"
                      alt={node.avatar.alt}
                      title={node.avatar.title}
                    />
                  )}
                  <span className="c-testimonial__author__citation">
                    <strong>
                      {node.name}, {node.jobTitle}
                    </strong>
                    , {node.companyName}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

TestimonialsHalf.defaultProps = {
  testimonials: [],
}

TestimonialsHalf.propTypes = {
  testimonials: PropTypes.arrayOf(PropTypes.object),
}

export default TestimonialsHalf
